import React, { useContext, useState ,useEffect} from "react";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../../../context/registration/registrationContext";
import ProgressButtons from "../ProgressButtons";
import SubFormButtons from "../SubFormButtons";
import findBrand from "../../findBrand";
import { brandDomains, fetchBrands } from "../../brand";

const R11ReleaseRequests = () => {
  const registrationContext = useContext(RegistrationContext);
  const {
    subFormLevels,
    formData: {
      releaseAudioAndVideo,
      firstName,
      releasePermissionForSocialMedia,
      releaseUseStudentWork,
      releasePermissionToTextStudent,
      releasePermissionToTextPg,
      releaseAllowStudentAccessToGoogleAppsForEducation,
    },
    onFormDataChange,
    pass: { releaseRequests },
  } = registrationContext;
  const [selectedOption, setSelectedOption] = useState("");

  const releaseRequest =
    releaseAudioAndVideo !== "" &&
    releasePermissionForSocialMedia !== "" &&
    releaseUseStudentWork !== "" &&
    releasePermissionToTextStudent !== "" &&
    releasePermissionToTextPg !== "" &&
    releaseAllowStudentAccessToGoogleAppsForEducation !== "";

  const releaseRequest1 =
    releasePermissionToTextStudent !== "" &&
    releasePermissionToTextPg !== "" &&
    releaseAllowStudentAccessToGoogleAppsForEducation !== "";

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  useEffect(() => {
    const loadBrands = async () => {
      await fetchBrands();
    };

    loadBrands();
  }, []);

  const brand_holston = brandDomains.brand_holston?.name;
  const brand_pbia = brandDomains.brand_pbia?.name;
  //const brand = findBrand()
  //findBrand is used to check whether holston forms or other forms
  if (findBrand(brand_holston) === true || findBrand(brand_pbia)=== true) {
    return (
      <>
        <div className="sub-form">
          {/* <h2 className="title">Release Requests</h2> */}
          <h2 className="">
            Release Requests <span>(10/11)</span>
            <hr />
          </h2>
          <div className="item">
            <div className="asterisk-group">
              <h3>
                Release: Permission to Text{" "}
                {firstName === "" ? "Student" : firstName}
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border: releaseRequests
                  ? "1px solid #ccc;"
                  : releasePermissionToTextStudent !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={releasePermissionToTextStudent["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="releasePermissionToTextStudent"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={releasePermissionToTextStudent["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="releasePermissionToTextStudent"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>Release: Permission to Text Parent/Guardians</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border: releaseRequests
                  ? "1px solid #ccc;"
                  : releasePermissionToTextPg !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={releasePermissionToTextPg["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="releasePermissionToTextPg"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={releasePermissionToTextPg["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="releasePermissionToTextPg"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                Release: Allow {firstName === "" ? " Student" : firstName}{" "}
                Access to Google Apps for Education (GAE)
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border: releaseRequests
                  ? "1px solid #ccc;"
                  : releaseAllowStudentAccessToGoogleAppsForEducation !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={
                    releaseAllowStudentAccessToGoogleAppsForEducation["yes"]
                  }
                  onChange={(e) => onFormDataChange(e)}
                  name="releaseAllowStudentAccessToGoogleAppsForEducation"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={
                    releaseAllowStudentAccessToGoogleAppsForEducation["no"]
                  }
                  onChange={(e) => onFormDataChange(e)}
                  name="releaseAllowStudentAccessToGoogleAppsForEducation"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>
          <div className="group">{subFormLevels.releaseRequests === 0}</div>
        </div>
        <ProgressButtons validation={releaseRequest1} name="releaseRequests" />
      </>
    );
  } else {
    return (
      <>
        <div className="sub-form">
          <h2 className="">
            Release Requests <span>(10/15)</span>
            <hr />
          </h2>
          <div className="item">
            <div className="asterisk-group">
              <h3>Release: Audio and Video</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <p className="under-title-note">
              I give permission for Audio/Video of{" "}
              {firstName === "" ? "the Student" : firstName} taken by the school
              to be used for school purposes.
            </p>
            <div
              className="flex-check-container"
              style={{
                border: releaseRequests
                  ? "1px solid #ccc;"
                  : releaseAudioAndVideo !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={releaseAudioAndVideo["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="releaseAudioAndVideo"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={releaseAudioAndVideo["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="releaseAudioAndVideo"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                Release: Permission for the School To Use{" "}
                {firstName === "" ? " Student" : firstName}'s Pictures, Audio,
                Video, and Student Work on Social Media{" "}
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </h3>
            </div>
            <p className="under-title-note">
              I give permission for the school to use{" "}
              {firstName === "" ? " Student" : firstName}'s pictures, audio,
              video, and student work on social media.
            </p>
            <div
              className="flex-check-container"
              style={{
                border: releaseRequests
                  ? "1px solid #ccc;"
                  : releasePermissionForSocialMedia !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={releasePermissionForSocialMedia["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="releasePermissionForSocialMedia"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={releasePermissionForSocialMedia["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="releasePermissionForSocialMedia"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>Release: Use Student Work</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <p className="under-title-note">
              I give permission for student work to be used in all school
              publications including the yearbook, newsletter, school bulletin
              boards, press releases, school web pages, or any other school
              sponsored displays.
            </p>
            <div
              className="flex-check-container"
              style={{
                border: releaseRequests
                  ? "1px solid #ccc;"
                  : releaseUseStudentWork !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={releaseUseStudentWork["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="releaseUseStudentWork"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={releaseUseStudentWork["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="releaseUseStudentWork"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                Release: Permission to Text{" "}
                {firstName === "" ? "Student" : firstName}
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border: releaseRequests
                  ? "1px solid #ccc;"
                  : releasePermissionToTextStudent !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={releasePermissionToTextStudent["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="releasePermissionToTextStudent"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={releasePermissionToTextStudent["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="releasePermissionToTextStudent"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>Release: Permission to Text Parent/Guardians</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border: releaseRequests
                  ? "1px solid #ccc;"
                  : releasePermissionToTextPg !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={releasePermissionToTextPg["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="releasePermissionToTextPg"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={releasePermissionToTextPg["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="releasePermissionToTextPg"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                Release: Allow {firstName === "" ? " Student" : firstName}{" "}
                Access to Google Apps for Education (GAE)
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border: releaseRequests
                  ? "1px solid #ccc;"
                  : releaseAllowStudentAccessToGoogleAppsForEducation !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={
                    releaseAllowStudentAccessToGoogleAppsForEducation["yes"]
                  }
                  onChange={(e) => onFormDataChange(e)}
                  name="releaseAllowStudentAccessToGoogleAppsForEducation"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={
                    releaseAllowStudentAccessToGoogleAppsForEducation["no"]
                  }
                  onChange={(e) => onFormDataChange(e)}
                  name="releaseAllowStudentAccessToGoogleAppsForEducation"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>
          <div className="group">{subFormLevels.releaseRequests === 0}</div>
        </div>
        <ProgressButtons validation={releaseRequest} name="releaseRequests" />
      </>
    );
  }
};

export default R11ReleaseRequests;